const QUICK_CARDS = [
  { tag: '红毯', time: '昨夜 22:40', title: '星光电影节红毯生图刚出炉，状态对比抢先看' },
  { tag: '综艺', time: '12:30 更新', title: '《今夜开麦》首期名场面完整复盘上线' },
  { tag: '热剧', time: '今晨 09:15', title: '《月落长街》首播口碑风向与幕后彩蛋盘点' },
];

export default function Hero() {
  return (
    <section id="top" className="relative min-h-[560px] md:min-h-[640px]">
      {/* background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Editorial%20magazine%20hero%20backdrop%20of%20a%20warm%20glowing%20concert%20and%20red%20carpet%20stage%20with%20spotlights%20and%20film%20cameras%20silhouettes%2C%20stylish%20abstract%20vermillion%20and%20cream%20graphic%20layers%2C%20dramatic%20depth%2C%20cinematic%20entertainment%20atmosphere&width=1600&height=900&seq=hero-stage-2026&orientation=landscape"
          alt="明星吃瓜现场直击娱乐舞台背景图"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/60 to-foreground-950/85"></div>
        <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-background-50 to-transparent"></div>
      </div>

      <div className="relative mx-auto flex max-w-7xl flex-col justify-end px-4 pb-10 pt-36 md:min-h-[640px] md:px-6 md:pb-14">
        <div className="flex max-w-3xl flex-col items-start">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/50 bg-foreground-950/40 px-4 py-1.5 text-xs font-semibold tracking-[0.22em] text-accent-300 backdrop-blur">
            <i className="ri-flashlight-line"></i> 明星吃瓜 · 现场第一线
          </span>
          <h2 className="mt-5 font-heading text-4xl font-black leading-[1.12] text-background-50 md:text-[64px] md:leading-[1.05]">
            红毯生图、现场名场面
            <br />
            <span className="text-accent-400">一次看齐最新瓜点</span>
          </h2>
          <p className="mt-5 max-w-xl text-[15px] leading-7 text-background-100/90 md:text-base">
            一手路透生图、现场视频片段与活动时间轴全收录。不用再在多平台来回翻找，把想看的真实瞬间，都端上你的瓜田。
          </p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#live"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-vidicon-line text-base"></i> 看现场直击
            </a>
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-100/40 bg-background-100/10 px-7 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-100/20"
            >
              围观热点热榜
            </a>
          </div>
        </div>

        {/* today's quick picks */}
        <div className="mt-10 grid w-full grid-cols-1 gap-3 sm:grid-cols-3">
          {QUICK_CARDS.map((c) => (
            <a
              key={c.title}
              href="#live"
              className="group rounded-2xl border border-background-100/15 bg-background-50/95 p-4 transition-colors hover:border-accent-400/60 hover:bg-background-50"
            >
              <div className="flex items-center justify-between">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-2.5 py-0.5 text-[11px] font-bold text-primary-700">
                  {c.tag}
                </span>
                <span className="text-[11px] text-foreground-500">{c.time}</span>
              </div>
              <p className="mt-2.5 line-clamp-2 text-sm font-medium leading-6 text-foreground-900 group-hover:text-primary-700">
                {c.title}
              </p>
              <span className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-primary-600">
                查看详情 <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}